export { default as CardInfo } from './CardInfo';

